var map = {
	"./breathing-awful.svg": "9a8b",
	"./breathing-bad.svg": "a306",
	"./breathing-fair.svg": "464b",
	"./breathing-good.svg": "4c5e",
	"./breathing-not_so_good.svg": "0b79"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "663d";